<template>
  <ModalComponent
    id="chat_room"
    :title="userName"
    :fullHeight="true"
    @modalClosed="updateScreen"
  >
    <template v-slot:content>
      <ChatRoom type="modal" />
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { pusherService } from "@/di/pusher";
import { syncSession } from "@/di/useCases";
import ChatRoom from "@/views/Chat/ChatRoom/ChatRoom.vue";

const store = useChatRoomConfigStore();
const userName = computed(() => store.config?.user_name);
const chatId = computed(() => store.config?.id);
const chatDate = computed(() => store.config?.date);

async function updateScreen() {
  const id = chatId.value;
  const date = chatDate.value;

  store.clear();
  await syncSession.execute();

  if (id && date) {
    pusherService.unsubscribe(`appointment_chat.${id}`, "new-message");
  }

  EventBus.$emit(EventBusNames.UPDATE_CHATS);
}
</script>

<style scoped></style>
